module.exports = __webpack_public_path__ + "files/7deb82e8dfc7c7175f022d29801dbda2.png";